module.exports = __webpack_public_path__ + "img/stretchlimo.c4cabc89.jpg";